<div class="s__logo-block">
  @if (heading()) {
    <p class="s__logo-block__heading" [innerHTML]="heading()"></p>
  }
  <div class="s__logo-block__grid">
    @for (logo of logos(); track logo.alt) {
      @if (logo.href) {
        <a [href]="logo.href" class="s__logo-block__item">
          @if (logo.src) {
            <img
              [ngSrc]="logo.src"
              sizes="auto, 200px"
              ngSrcset="64w, 96w, 128w, 256w, 384w, 640w"
              [width]="logo.width || 200"
              [height]="logo.height || 100"
              [alt]="logo.alt"
            />
          }
        </a>
      } @else {
        <div class="s__logo-block__item">
          @if (logo.src) {
            <img
              [ngSrc]="logo.src"
              sizes="auto, 200px"
              ngSrcset="64w, 96w, 128w, 256w, 384w, 640w"
              [width]="logo.width || 200"
              [height]="logo.height || 100"
              [alt]="logo.alt"
            />
          }
        </div>
      }
    }
  </div>
</div>
